import React, { useEffect } from 'react';

import type { ResultType } from '../../../constants/global';
import { useGlobalContext } from '../../../context/global';
import { TypeButton } from '../../utils/button';
import { CopyValue } from '../../utils/copy';
import { RefreshComponent } from '../../utils/hooks';
import { CheckSVG, InfoSVG } from '../../utils/svgs';
import type { IChildCode } from './utils';

const getResultCodeTitle = (resultType: ResultType) => {
	switch (resultType) {
		case 'EC8B':
			return { parent: 'Ward', child: 'Polling Unit' };
		case 'EC8C':
			return { parent: 'LGA', child: 'Ward' };
		case 'EC8D':
			return { parent: 'State', child: 'LGA' };
		default:
			return { parent: '', child: '' };
	}
};

const ChildCodesStage = () => {
	const {
		global: {
			state: { resultType, childCodes },
			updateState,
		},
		getCodeProps,
	} = useGlobalContext();
	const title = getResultCodeTitle(resultType as ResultType);
	const completed = childCodes.filter((i) => i.status)?.length || 0;

	const onChildCode = (data: IChildCode) => () => {
		updateState('selectedChildCode', data);
		updateState('partyVoteStage', 'Party Votes');
	};

	const { handleCodes, load } = getCodeProps;

	useEffect(() => {
		handleCodes();
	}, []);

	return (
		<div className='f-column-33'>
			<div className='f-column-13'>
				<div className='upload-result__info-card'>
					<div className='upload-result__info-card-icon'>
						<InfoSVG
							color='var(--info-600)'
							width='16'
							height='16'
						/>
					</div>
					<p className='upload-result__info-card-text'>
						Ensure you enter the political parties vote count for each <b>{title.child}</b> listed below.
					</p>
				</div>
				<div className='f-row-7 align-items-center hw-mx cursor-pointer'>
					<p className='m-0 text-little color-label'>Refresh</p>
					<RefreshComponent
						onRefresh={handleCodes}
						load={load}
					/>
				</div>
			</div>
			<div className='text-center f-row-13 align-items-center justify-content-center'>
				<p className='text-little m-0'>{title.child} Codes</p>
				<p className='color-label text-little m-0'>
					( {completed} of {childCodes.length} completed )
				</p>
			</div>
			<div className='grid-wrapper-45 gap-33'>
				{childCodes.map((i) => (
					<div
						className='f-column-7 upload-code-card'
						key={i.status + i?.code}
					>
						<TypeButton
							title={`${i.name} [ ${i?.code} ]`}
							buttonType='outlined'
							buttonSize='small'
							className='w-100'
							icon={i.status ? <CheckSVG color='green' /> : <></>}
							onClick={onChildCode(i)}
						/>
						<CopyValue
							variant='inline'
							display={i?.code}
							value={i?.code}
							label='code'
							className='upload-code-card__copy'
						/>
					</div>
				))}
			</div>
		</div>
	);
};

export default ChildCodesStage;
